import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./App";
import type { Product } from "@fa/shared";

function mount() {
  const nodes = document.querySelectorAll<HTMLDivElement>("[id^='fa-calc-root']");
  nodes.forEach((node) => {
    const product = (node.dataset.product as Product) ?? "motor_private";
    const apiBase =
      node.dataset.apiBase ??
      (window as unknown as { FA_CALC_API_BASE?: string }).FA_CALC_API_BASE ??
      "/api";
    ReactDOM.createRoot(node).render(
      <React.StrictMode>
        <App product={product} apiBase={apiBase} />
      </React.StrictMode>,
    );
  });
}

function installIframeResizer() {
  if (window.self === window.top) return; // not in an iframe
  const ro = new ResizeObserver(() => {
    window.parent.postMessage(
      { type: "fa-calc:resize", height: document.documentElement.scrollHeight },
      "*",
    );
  });
  ro.observe(document.documentElement);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    mount();
    installIframeResizer();
  });
} else {
  mount();
  installIframeResizer();
}
